export default "__VITE_ASSET__f7d71c09__"